module.exports = __webpack_public_path__ + "img/caret.ee88783d.svg";